import graphql__a6cbd38051a027da8d09 from "./__generated__/ContributionsMapContributionsManager_participativeModule.graphql.js";
import graphql__e68b088a9dcb14ffb596 from "./__generated__/ContributionsMapContributionsManagerQuery.graphql.js";import { graphql, useFragment } from "react-relay";

import AppQueryRenderer from "../../../AppQueryRenderer";
import { CONTRIBUTIONS_BATCH_SIZE } from "./ContributionsMapContributionsList";
import { COMMENTS_BATCH_SIZE } from "../../../Comments/CommentsList";
import { BoxSpinner } from "../../../Utils/Spinner";
import ContributionsMapContributionsList from "./ContributionsMapContributions";

const ContributionsMapContributionsManager = props => {
  const { slug: participativeModuleSlug } = useFragment(
    ContributionsMapContributionsManager_participativeModule,
    props.participativeModule
  );

  const contributionsCount = CONTRIBUTIONS_BATCH_SIZE;
  const commentsCount = COMMENTS_BATCH_SIZE;

  return (
    <AppQueryRenderer
      query={ContributionsMapContributionsManagerQuery}
      variables={{ participativeModuleSlug, contributionsCount, commentsCount }}
      component={ContributionsMapContributionsList}
      loader={<BoxSpinner />}
    />
  );
};

const ContributionsMapContributionsManager_participativeModule = graphql__a6cbd38051a027da8d09;

const ContributionsMapContributionsManagerQuery = graphql__e68b088a9dcb14ffb596;

export default ContributionsMapContributionsManager;
